$('.gmVdoSldWrap .imgTar').on('click',(el)=>{
    let hgt,wgt;
    let vdoEl = document.createElement('video');
    if(el.currentTarget.nodeName == 'svg')
    {
        hgt = $(el.currentTarget.parentElement).find('img.imgTar')[0].height;
        wgt = $(el.currentTarget.parentElement).find('img.imgTar')[0].width;
    }else{
        hgt = el.currentTarget.height;
        wgt = el.currentTarget.width;
    }
    vdoEl.autoplay = true;
    vdoEl.muted = true;
    vdoEl.loop = true;
    vdoEl.src = el.currentTarget.parentElement.dataset.url;
    vdoEl.height = hgt;
    vdoEl.width = wgt;
    vdoEl.play();
    el.currentTarget.parentElement.appendChild(vdoEl);
    let tar = el.currentTarget.parentElement.dataset.target;
    $(el.currentTarget.parentElement).children('[data-sound="false"]').addClass('active');
    $(el.currentTarget.parentElement).children('[data-sound="true"]').removeClass('active');
    $('.'+tar).hide();
});
$('.gmSVG').on('click',(el)=>{
  let vdo = $(el.currentTarget.parentElement).children('video');
  if(el.currentTarget.dataset.sound == 'false'){
    $(el.currentTarget.parentElement).children('[data-sound="false"]').removeClass('active');
    $(el.currentTarget.parentElement).children('[data-sound="true"]').addClass('active');
    vdo[0].muted = false;
  }else if(el.currentTarget.dataset.sound == 'true'){
    $(el.currentTarget.parentElement).children('[data-sound="false"]').addClass('active');
    $(el.currentTarget.parentElement).children('[data-sound="true"]').removeClass('active');
    vdo[0].muted = true;
  }
});